import { TextareaAutosize } from "@mui/material";
import { styled, SxProps } from "@mui/material/styles";
import { FountainBlue } from "@themes:palette";
import { ChangeEvent } from "react";

const CustomTextarea = styled(TextareaAutosize)(() => ({
  "&:focus-visible": {
    outline: `2px solid ${FountainBlue[600]}`,
  },
  outline: "none",
  border: "none",
  resize: "vertical",
  fontFamily: "Plus Jakarta Sans Variable, sans-serif",
  fontSize: 16,
  lineHeight: 1.5,
}));

interface TextareaProps {
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  value: string;
  placeholder?: string;
  minRows?: number;
  sx?: SxProps;
}

export const Textarea = ({
  onChange,
  value,
  placeholder,
  minRows,
  sx,
}: TextareaProps) => {
  return (
    <CustomTextarea
      sx={{
        p: 2,
        bgcolor: "#F2F2F2",
        borderRadius: 2,
        width: "100%",
        ...sx,
      }}
      minRows={minRows}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
    />
  );
};
